import { commitMutation } from 'react-relay';
import { environment } from '../Environment';
import { captureException } from './ExceptionsCaptureHelper';

const createMutation = config =>
  new Promise((resolve, reject) =>
    commitMutation(environment, {
      onCompleted: (response, errors) => {
        // $('.js-form-changes-handler').data('changed', false);
        if (!response && errors && errors.length !== 0) {
          return reject(errors);
        }

        return resolve(response);
      },

      onError: error => {
        captureException({
          type: 'GraphQL Mutation Error',
          message: error.message || error || 'Something went wrong',
          withScope: scope => {
            scope.setExtra('Mutation', JSON.stringify(config.mutation));
            scope.setExtra('Variables', JSON.stringify(config.variables));
          }
        });

        return reject(error);
      },

      ...config
    })
  );

export default createMutation;
